Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetPagination = void 0;
var GetPagination = exports.GetPagination = function GetPagination(_ref) {
  var currentPage = _ref.currentPage,
    _ref$itemsPerPage = _ref.itemsPerPage,
    itemsPerPage = _ref$itemsPerPage === void 0 ? 10 : _ref$itemsPerPage,
    _ref$totalItems = _ref.totalItems,
    totalItems = _ref$totalItems === void 0 ? 0 : _ref$totalItems;
  var _lastPage = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  return {
    current: currentPage,
    first: 1,
    last: _lastPage,
    next: Math.min(_lastPage, currentPage + 1),
    previous: Math.max(1, currentPage - 1),
    visible: _lastPage > 1
  };
};